<template>
    <div>
        <div v-if="isShowingEdit">
            <el-button size="small" icon="el-icon-edit" @click="handleMultipleEdit">Multiple Edit</el-button>

            <general-dialog :is-dialog.sync="isMultipleEdit" :title="editMultipleTitle" :dialog-width="dialogWidth" @handleConfirm="saveCreateBatch()">
                <template #content>
                    <create-edit-palm-form />
                </template>
            </general-dialog>
        </div>
    </div>
</template>

<script>
import GeneralDialog from "@/components/Dialog/GeneralDialog";
import CreateEditPalmForm from "@/components/Palm/CreateEditPalmForm";

export default {
    components: {
        "general-dialog": GeneralDialog,
        "create-edit-palm-form": CreateEditPalmForm,
    },
    props: {
        isBatchEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMultipleEdit: false,
            editMultipleTitle: "Edit Multiple",
            dialogWidth: "60%"
        };
    },
    computed: {
        isShowingEdit: {
            get() {
                return this.isBatchEdit;
            },
            set(value) {
                this.$emit("update:isBatchEdit", value);
            }
        }
    },
    methods: {
        handleMultipleEdit() {
            this.isMultipleEdit = true;
        }
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmMultipleEdit.vue